import React from 'react';

interface Props {
  onClick: () => void;
  loading: boolean;
  hasMore: boolean;
}

export default function LoadMoreButton({ onClick, loading, hasMore }: Props) {
  if (!hasMore && !loading) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '32px 0' }}>
      <button
        onClick={onClick}
        disabled={loading}
        style={{
          padding: '14px 48px',
          borderRadius: 10,
          border: 'none',
          background: loading ? '#00a855' : '#00bf62',
          color: '#fff',
          fontWeight: 600,
          fontSize: 16,
          cursor: loading ? 'default' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          opacity: loading ? 0.8 : 1,
          transition: 'background 0.15s, opacity 0.15s',
          boxShadow: '0 2px 8px rgba(0, 191, 98, 0.3)',
        }}
      >
        {loading && (
          <span
            style={{
              width: 16,
              height: 16,
              border: '2px solid rgba(255,255,255,0.4)',
              borderTopColor: '#fff',
              borderRadius: '50%',
              display: 'inline-block',
              animation: 'pageLoaderSpin 0.7s linear infinite',
            }}
          />
        )}
        {loading ? 'Loading...' : 'Load More'}
      </button>
    </div>
  );
}
